export default {
      id: "smile-alt-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#smile-alt",
      toString: function () {
        return this.url;
      }
    }